/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directtobank_PayoutsInputs */

const en_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct-to-bank payouts`)
};

const es_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagos directos al banco`)
};

const fr_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiements directs vers la banque`)
};

const de_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direkte Auszahlungen auf die Bank`)
};

const ja_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`銀行への直接支払い`)
};

const zh_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直接提现至银行账户`)
};

const ar_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدفوعات مباشرة إلى البنك`)
};

const id_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran langsung-ke-bank`)
};

const it_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamenti diretti sul conto bancario`)
};

const ru_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прямые выплаты на банковский счет`)
};

const pt_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamentos diretos para a conta bancária`)
};

const ko_directtobank_payouts = /** @type {(inputs: Directtobank_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`은행으로의 직접 정산`)
};

/**
* | output |
* | --- |
* | "Direct-to-bank payouts" |
*
* @param {Directtobank_PayoutsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const directtobank_payouts = /** @type {((inputs?: Directtobank_PayoutsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directtobank_PayoutsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directtobank_payouts(inputs)
	if (locale === "es") return es_directtobank_payouts(inputs)
	if (locale === "fr") return fr_directtobank_payouts(inputs)
	if (locale === "de") return de_directtobank_payouts(inputs)
	if (locale === "ja") return ja_directtobank_payouts(inputs)
	if (locale === "zh") return zh_directtobank_payouts(inputs)
	if (locale === "ar") return ar_directtobank_payouts(inputs)
	if (locale === "id") return id_directtobank_payouts(inputs)
	if (locale === "it") return it_directtobank_payouts(inputs)
	if (locale === "ru") return ru_directtobank_payouts(inputs)
	if (locale === "pt") return pt_directtobank_payouts(inputs)
	return ko_directtobank_payouts(inputs)
});